module.exports = __webpack_public_path__ + "static/media/golden-member-desktop.1472f945.svg";